import {
  actionTypes,
  CreateUserFormError,
  CreateUserProps,
  ResetPasswordInput,
  UpdatePasswordInput,
  UpdateSingleAuthDataInput,
  UserPayloadProps,
  UserProps,
} from "./actionType";
import {
  executeMutation,
  executeQuery,
} from "../../../../utils/services/apiServices";
import { showSnackbar } from "utils/snack_bar/store/action";
import { setError } from "utils/flash_error/store/action";
import {
  CREATE_USER,
  RESET_PASSWORD,
  UPDATE_PASSWORD,
  UPDATE_USER,
  UPDATE_USER_ROLE,
} from "../graphql/mutation";
import { CHECK_EXISTING_USER, fetchUser } from "../graphql/query";


export const fetchUsersRequest = () => ({
  type: actionTypes.FETCH_USERS_REQUEST,
});
export const fetchUsersSuccess = (payload: UserProps[]) => ({
  type: actionTypes.FETCH_USERS_SUCCESS,
  payload,
});
export const fetchUsersFail = (payload: string) => ({
  type: actionTypes.FETCH_USERS_FAIL,
  payload,
});
export const fetchUsers = (status: string) => {
  return async (dispatch: any) => {
    try {
      await dispatch(fetchUsersRequest());
      const input = {
        status: status,
      };
      const response = await executeQuery(fetchUser, input);
      const jsonData = response.data?.fetchUsers;
      if (jsonData?.error === null) {
        dispatch(fetchUsersSuccess(jsonData?.data.users));
      } else {
        dispatch(fetchUsersFail(jsonData?.error.message));
      }
    } catch (error: any) {
      dispatch(fetchUsersFail("Failed to fetch fetchUsers(s)"));
    }
  };
};


//createUser
export const createUserRequest = () => ({
  type: actionTypes.CREATE_USER_REQUEST,
});
export const createUserSuccess = (payload:UserProps) => ({
  type: actionTypes.CREATE_USER_SUCCESS,
  payload,
});
export const createUserFail = (payload: string) => ({
  type: actionTypes.CREATE_USER_FAIL,
  payload,
});
export const createUser = (user_input: CreateUserProps) => {
  return async (dispatch: any) => {
    try {
      dispatch(createUserRequest());
      const response = await executeMutation(CREATE_USER, { user_input });
      const jsonData = response.data?.createUser;
      if (jsonData?.error === null) {
        dispatch(createUserSuccess(jsonData?.data.user)); // Use the user object
        dispatch(showSnackbar("Success! User created."));
      } else {
        dispatch(createUserFail(jsonData?.error.message));
        dispatch(showSnackbar(`Error: ${jsonData?.error.message}`));
      }
    } catch (error: any) {
      dispatch(createUserFail("Failed to create user."));
    }
  };
};


//update
export const updatedUserRequest = () => ({
  type: actionTypes.UPDATE_USER_REQUEST,
});
export const updatedUserSuccess = (payload: UserPayloadProps) => ({
  type: actionTypes.UPDATE_USER_SUCCESS,
  payload,
});
export const updatedUserFail = (payload: string) => ({
  type: actionTypes.UPDATE_USER_FAIL,
  payload,
});
export const authLogin = (input: UpdateSingleAuthDataInput) => {
  return async (dispatch: any) => {
    try {
      await dispatch(updatedUserRequest());
      const response = await executeMutation(UPDATE_USER, input);
      const jsonData = response.data?.updateSingleUserDataById;
      if (jsonData?.error) {
        const errorMessage = jsonData.error.message;
        dispatch(updatedUserFail(errorMessage));
        dispatch(showSnackbar(`Error: ${errorMessage}`));
        return;
      }
      const payload: UserPayloadProps = {
        user: jsonData.data.user,
      };
      dispatch(updatedUserSuccess(payload));
    } catch (error: any) {
      dispatch(updatedUserFail("Something went wrong"));
    }
  };
};

//SaveFormData
export const saveCreateUserFormData = (payload: CreateUserProps) => {
  return async (dispatch: any) => {
    dispatch({
      type: actionTypes.SAVE_CREATE_USER_FORM_DATA,
      payload,
    });
  };
};

//reset State
export const resetState = () => {
  return async (dispatch: any) => {
    dispatch({
      type: actionTypes.RESET_CREATE_USER_STATE,
    });
  };
};

//set ErrorState
export const updateCreateUserFormErrorState = (data: CreateUserFormError) => {
  return async (dispatch: any) => {
    dispatch({
      type: actionTypes.UPDATE_CREATE_USER_FORM_ERROR,
      payload: data,
    });
  };
};

//CheckForExistingUserByMobile
export const checkForExistingUserByMobileResuest = () => ({
  type: actionTypes.CHECK_FOR_EXISTING_USER_BY_MOBILE_REQUEST,
});
export const checkForExistingUserByMobileSuccess = () => ({
  type: actionTypes.CHECK_FOR_EXISTING_USER_BY_MOBILE_SUCCESS,
});
export const checkForExistingUserByMobileFail = (payload: string) => ({
  type: actionTypes.CHECK_FOR_EXISTING_USER_BY_MOBILE_FAIL,
  payload,
});
export const checkForExistingUserByMobile = (data: String) => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkForExistingUserByMobileResuest());
      const input = {
        field: "mobile_no",
        value: data,
      };
      const response = await executeQuery(CHECK_EXISTING_USER, input);
      const jsonData = response.data?.checkForExistingUser;
      if (jsonData?.error === null && !jsonData?.data.exist_user) {
        dispatch(checkForExistingUserByMobileSuccess());
      } else {
        dispatch(
          setError(
            jsonData?.error?.message ??
              "User with given mobile no already exist"
          )
        );
        dispatch(
          checkForExistingUserByMobileFail(
            jsonData?.error?.message ??
              "User with given mobile no already exist"
          )
        );
      }
    } catch (error: any) {
      dispatch(checkForExistingUserByMobileFail("Something went wrong"));
    }
  };
};

//CheckForExistingUserByEmail
export const checkForExistingUserByEmailResuest = () => ({
  type: actionTypes.CHECK_FOR_EXISTING_USER_BY_EMAIL_REQUEST,
});
export const checkForExistingUserByEmailSuccess = () => ({
  type: actionTypes.CHECK_FOR_EXISTING_USER_BY_EMAIL_SUCCESS,
});
export const checkForExistingUserByEmailFail = (payload: string) => ({
  type: actionTypes.CHECK_FOR_EXISTING_USER_BY_EMAIL_FAIL,
  payload,
});
export const checkForExistingUserByEmail = (data: string) => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkForExistingUserByEmailResuest());
      const input = {
        field: "email",
        value: data,
      };
      const response = await executeQuery(CHECK_EXISTING_USER, input);
      const jsonData = response.data?.checkForExistingUser;
      if (jsonData?.error === null && !jsonData?.data.exist_user) {
        dispatch(checkForExistingUserByEmailSuccess());
      } else {
        dispatch(
          checkForExistingUserByEmailFail(
            jsonData?.error?.message ?? "User with given email already exist"
          )
        );
      }
    } catch (error: any) {
      dispatch(checkForExistingUserByEmailFail("Something went wrong"));
    }
  };
};

//UPDATE USER (email or mobile no)
export const updatedSingleUserDataRequest = () => ({
  type: actionTypes.CHANGE_USER_DETAIL_REQUEST,
});
export const updatedSingleUserDataSuccess = (payload: UserProps) => ({
  type: actionTypes.CHANGE_USER_DETAIL_SUCCESS,
  payload,
});
export const updatedSingleUserDataFail = (payload: string) => ({
  type: actionTypes.CHANGE_USER_DETAIL_FAIL,
  payload,
});
export const updatedSingleUserData = (input: UpdateSingleAuthDataInput, user_id:string) => {
  return async (dispatch: any) => {
    try {
      await dispatch(updatedSingleUserDataRequest());
      const response = await executeMutation(UPDATE_USER, {input: input, user_id });
      const jsonData = response.data?.updateSingleUserDataById;
      if (jsonData?.error === null) {
        dispatch(updatedSingleUserDataSuccess(jsonData?.data.user));
        if (input.field && input.value === jsonData?.data.user.email) {
          dispatch(showSnackbar("Success! Email has been updated!"));
        }
        if (input.field && input.value === jsonData?.data.user.mobile_no) {
          dispatch(showSnackbar("Mobile Number has been updated!"));
        }
      } else {
        dispatch(updatedSingleUserDataFail(jsonData?.error.message));
        dispatch(showSnackbar(`Error: ${jsonData?.error.message}`));
      }
    } catch (error: any) {
      dispatch(
        updatedSingleUserDataFail("An error occurred while fetching user data")
      );
    }
  };
};

//change user name
export const updatedSingleUserNameRequest = () => ({
  type: actionTypes.CHANGE_USER_NAME_REQUEST,
});
export const updatedSingleUserNameSuccess = (payload: UserProps) => ({
  type: actionTypes.CHANGE_USER_NAME_SUCCESS,
  payload,
});
export const updatedSingleUserNameFail = (payload: string) => ({
  type: actionTypes.CHANGE_USER_NAME_FAIL,
  payload,
});
export const updatedSingleUserName = (input: UpdateSingleAuthDataInput, user_id:string) => {
  return async (dispatch: any) => {
    const inputData = { input: input };
    try {
      await dispatch(updatedSingleUserNameRequest());
      const response = await executeMutation(UPDATE_USER, {user_id, input: input });
      const jsonData = response.data?.updateSingleUserDataById;
      if (jsonData?.error === null) {
        dispatch(updatedSingleUserNameSuccess(jsonData?.data.user));
        if (input.field && input.value === jsonData?.data.user.name) {
          dispatch(showSnackbar("Success! Name has been updated!"));
        }
      } else {
        dispatch(updatedSingleUserNameFail(jsonData?.error.message));
        dispatch(showSnackbar(`Error: ${jsonData?.error.message}`));
      }
    } catch (error: any) {
      dispatch(
        updatedSingleUserNameFail("An error occurred while fetching user data")
      );
    }
  };
};

//change user password
export const updatedSingleUserPasswordRequest = () => ({
  type: actionTypes.CHANGE_USER_PASSWORD_REQUEST,
});
export const updatedSingleUserPasswordSuccess = (payload: string) => ({
  type: actionTypes.CHANGE_USER_PASSWORD_SUCCESS,
  payload,
});
export const updatedSingleUserPasswordFail = (payload: string) => ({
  type: actionTypes.CHANGE_USER_PASSWORD_FAIL,
  payload,
});
export const UpdateUserPassword = (input: UpdatePasswordInput) => {
  return async (dispatch: any, state: any) => {
    try {
      const input_data = {
        input: input,
      };
      dispatch(updatedSingleUserPasswordRequest());
      const response = await executeMutation(UPDATE_PASSWORD, input_data);
      const jsonData = response.data?.updatePassword;
      if (jsonData?.error === null) {
        dispatch(updatedSingleUserPasswordSuccess(jsonData?.data.message));
        dispatch(showSnackbar("Success! Password updated."));
      } else {
        dispatch(updatedSingleUserPasswordFail(jsonData?.error.message));
        dispatch(showSnackbar(`Error: ${jsonData?.error.message}`));
      }
    } catch (error: any) {
      dispatch(updatedSingleUserPasswordFail("Failed to update the password."));
    }
  };
};

//reset user password
export const resetUserPasswordRequest = () => ({
  type: actionTypes.RESET_USER_PASSWORD_REQUEST,
});
export const resetUserPasswordSuccess = (payload: string) => ({
  type: actionTypes.RESET_USER_PASSWORD_SUCCESS,
  payload,
});
export const resetUserPasswordFail = (payload: string) => ({
  type: actionTypes.RESET_USER_PASSWORD_FAIL,
  payload,
});
export const RestUserPassword = (input: ResetPasswordInput) => {
  return async (dispatch: any, state: any) => {
    try {
      const input_data = {
        input: input,
      };
      dispatch(resetUserPasswordRequest());
      const response = await executeMutation(RESET_PASSWORD, input_data);
      const jsonData = response.data?.resetPassword;
      if (jsonData?.error === null) {
        dispatch(resetUserPasswordSuccess(jsonData?.data.message));
        dispatch(showSnackbar("Success! password reset."));
      } else {
        dispatch(resetUserPasswordFail(jsonData?.error.message));
        dispatch(showSnackbar(`Error: ${jsonData?.error.message}`));
      }
    } catch (error: any) {
      dispatch(resetUserPasswordFail("Failed to reset the password."));
    }
  };
};

//update user roles
export const updateUserRolesRequest = () => ({
  type: actionTypes.UPDATE_USER_ROLES_REQUEST,
});
export const updateUserRolesSuccess = (payload: UserProps) => ({
  type: actionTypes.UPDATE_USER_ROLES_SUCCESS,
  payload,
});
export const updateUserRolesFail = (payload: string) => ({
  type: actionTypes.UPDATE_USER_ROLES_FAIL,
  payload,
});
export const updateUserRoles = (user_id: string, role_ids: string[]) => {
  return async (dispatch: any) => {
    try {
      dispatch(updateUserRolesRequest());
      const response = await executeMutation(UPDATE_USER_ROLE, { user_id, role_ids });
      const jsonData = response.data?.updateUserRoles;
      if (jsonData?.error === null) {
        dispatch(updateUserRolesSuccess(jsonData?.data.user));
        dispatch(showSnackbar("Success! User roles updated."));
      } else {
        dispatch(updateUserRolesFail(jsonData?.error.message));
        dispatch(showSnackbar(`Error: ${jsonData?.error.message}`));
      }
    } catch (error: any) {
      dispatch(updateUserRolesFail("Failed to update user roles."));
    }
  };
};